import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import VueAxios from 'vue-axios'

import authStore from './authStore'
import shared from './sharedStore'
import gymStore from './gymStore'
import coachStore from './coachStore'
import partnerStore from './partnerStore'
import kineStore from './kineStore'
import nutritionStore from './nutritionStore'
import livePlanningStore from './livePlanningStore'
import BusinessStore from './businessStore'
import userStore from './userStore'
import clientMessageStore from './contactStore'
import notificationStore from './notificationStore.js'
import monitoringStore from './monitoringStore.js'
import paymentStore from './paymentStore'

Vue.use(Vuex)
Vue.use(VueAxios, Axios)

export default new Vuex.Store({
  modules: {
    authStore,
    shared,
    gymStore,
    coachStore,
    kineStore,
    nutritionStore,
    BusinessStore,
    userStore,
    clientMessageStore,
    notificationStore,
    livePlanningStore,
    monitoringStore,
    partnerStore,
    paymentStore
  }
})
